"use strict";
/**
 * trsTrustHtmlModule
 *
 * Description  信任HTML
 */
angular.module('trsTrustHtmlModule', []).
filter("trsTrustHtml", ['$sce', function($sce) {
    return function(text) {
        return $sce.trustAsHtml(text);
    };
}]).
filter("filterStyleHtml", ['$sce', function($sce) {
    return function(text) { 
        return $sce.trustAsHtml(text.replace(/<style(([\s\S])*?)<\/style>/g, ''));
    };
}]).
filter("toStandardRedHtml", function($sce){
    var getHighlight = function(text, search){
        if (!search) return $sce.trustAsHtml(text);
        var regex = new RegExp(search, 'gi');
        var result = text.replace(regex, '<span style="color:red;">$&</span>');
        return $sce.trustAsHtml(result);
    };
    return getHighlight;
}).
filter("hotTimeAxisHtml", function($sce){
    var getHighlight = function(text, search){
        if (!search) return $sce.trustAsHtml(text);
        var regex = new RegExp(search, 'gi');
        var result = text.replace(regex, '<span style="color:#d64541;">$&</span>');
        return $sce.trustAsHtml(result);
    };
    return getHighlight;
});
